import React from 'react';
import { Card, Typography, Row, Col, Button, Tooltip, Popconfirm } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { QuestionCircleOutlined } from '@ant-design/icons';
import {
  customerRoutes,
  routes,
  subRoutes
} from '../../utils/constants/routes';
import useAuthContext from '../../contexts/AuthContext';

const customerShortcuts = [
  {
    title: 'Mes contrats',
    path: customerRoutes.CONTRACTS_CUSTOMER
  },
  {
    title: 'Mes pièces manquantes',
    path: customerRoutes.MISSING_PARTS
  },
  {
    title: 'Mes documents',
    path: customerRoutes.CONTRACTS_CUSTOMER
  },
  {
    title: 'Mes règlements & factures',
    path: customerRoutes.ACCOUNTING
  },
  {
    title: 'Mes attestations',
    path: customerRoutes.CONTRACTS_CUSTOMER
  },
  {
    title: 'Mes sinistres',
    path: customerRoutes.CLAIMS
  }
];

const ShortcutsCard = () => {
  const navigate = useNavigate();
  const { productAccess, user } = useAuthContext();
  const { t } = useTranslation();

  const getProductUrl = (productTitle) => {
    switch (productTitle) {
      case 'mrb':
        return 'mrp';
      case 'rcp':
        return 'rcp';
      case 'mri':
        return 'mri';
      default:
        return productTitle;
    }
  };

  const getLocation = (productTitle) => {
    const product = getProductUrl(productTitle);
    return {
      pathname: `/quotes/productsquote/${product.slice(0, 3)}`,
      state: { product }
    };
  };

  return (
    <Card title="Mes raccourcis" className="shortcut-card-home">
      <Row gutter={user?.role !== 'guests:GUEST' ? [] : [16, 8]}>
        {user?.role !== 'guests:GUEST' ? (
          <>
            <Col xs={24} sm={24} md={15} xl={24} xxl={15}>
              <Typography.Title level={4}>Faire un devis</Typography.Title>
              <Row gutter={[8, 6]}>
                {productAccess
                  .sort((p1, p2) => p1.order - p2.order)
                  .map((s) => {
                    if (s.title === 'mrp') {
                      return (
                        <Tooltip title={s.description} key={s.title}>
                          <Col xs={24} sm={12} xl={8}>
                            <Popconfirm
                              title={t('quotes.productsquote.confirmMRP.title')}
                              okText={t(
                                'quotes.productsquote.confirmMRP.okText'
                              )}
                              cancelText={t(
                                'quotes.productsquote.confirmMRP.cancelText'
                              )}
                              cancelButtonProps={{ type: 'primary' }}
                              onConfirm={() => navigate(getLocation('mrp'))}
                              onCancel={() => navigate(getLocation('mrpb'))}
                              icon={
                                <QuestionCircleOutlined
                                  style={{ color: 'var(--clientColor)' }}
                                />
                              }
                              style={{
                                color: '#fff',
                                margin: 'auto',
                                display: 'flex'
                              }}
                            >
                              <Button>
                                <img
                                  src={s.shortCutsImage}
                                  alt={`${s.title.toUpperCase()} icon`}
                                />
                                {s.title.substr(0, 3).toUpperCase()}
                              </Button>
                            </Popconfirm>
                          </Col>
                        </Tooltip>
                      );
                    }
                    if (s.title === 'association') {
                      return (
                        <Tooltip title={s.description} key={s.title}>
                          <Col xs={24} sm={12} xl={8}>
                            <Popconfirm
                              title={t(
                                'quotes.productsquote.confirmASSO.title'
                              )}
                              okText={t(
                                'quotes.productsquote.confirmASSO.okText'
                              )}
                              cancelText={t(
                                'quotes.productsquote.confirmASSO.cancelText'
                              )}
                              cancelButtonProps={{ type: 'primary' }}
                              onConfirm={() =>
                                navigate(
                                  `/quotes/${s.title}/create?assoT=localRc`
                                )
                              }
                              onCancel={() =>
                                navigate(`/quotes/${s.title}/create?assoT=rc`)
                              }
                              icon={
                                <QuestionCircleOutlined
                                  style={{ color: 'var(--clientColor)' }}
                                />
                              }
                              style={{
                                color: '#fff',
                                margin: 'auto',
                                display: 'flex'
                              }}
                            >
                              <Button>
                                <img
                                  src={s.shortCutsImage}
                                  alt={`${s.title.toUpperCase()} icon`}
                                />
                                {s.title.substr(0, 3).toUpperCase()}
                              </Button>
                            </Popconfirm>
                          </Col>
                        </Tooltip>
                      );
                    }
                    if (
                      s.title === 'rcp' ||
                      s.title === 'mrb' ||
                      s.title === 'mri' ||
                      s.title === 'rcngawk'
                    ) {
                      return (
                        <Tooltip title={s.description} key={s.title}>
                          <Col xs={24} sm={12} xl={8}>
                            <Button
                              className={
                                s.title === 'rcngawk' ? 'border-gold pulse' : ''
                              }
                              onClick={() => navigate(getLocation(s.title))}
                            >
                              <img
                                src={s.shortCutsImage}
                                alt={`${s.title.toUpperCase()} icon`}
                              />
                              {s.title.substr(0, 3).toUpperCase()}
                            </Button>
                          </Col>
                        </Tooltip>
                      );
                    }
                    if (
                      !s.title.includes('sm') &&
                      !s.title.includes('hx') &&
                      s.title !== 'pne'
                    ) {
                      return (
                        <Tooltip title={s.description} key={s.title}>
                          <Col xs={24} sm={12} xl={8}>
                            <Link
                              to={`${routes.QUOTES}/${
                                s.titleLink || s.title
                              }/create${s.search || ''}`}
                              style={{ width: '100%' }}
                            >
                              <Button>
                                <img
                                  src={s.shortCutsImage}
                                  alt={`${s.title.toUpperCase()} icon`}
                                />
                                {s.title.substr(0, 3).toUpperCase()}
                              </Button>
                            </Link>
                          </Col>
                        </Tooltip>
                      );
                    }
                    return <></>;
                  })}
              </Row>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={9}
              xl={24}
              xxl={9}
              className="shortcut-card-right-col"
            >
              <Button
                type="primary"
                onClick={() =>
                  navigate(`${routes.QUOTES}${subRoutes.QUOTES.QUOTES_SAVED}`)
                }
              >
                Voir mes devis
              </Button>
              <Button
                type="primary"
                onClick={() =>
                  navigate(
                    `${routes.QUOTES}${subRoutes.QUOTES.QUOTES_IN_EXEMPTION}`
                  )
                }
              >
                Voir mes devis en dérogation
              </Button>
              <Button
                type="primary"
                onClick={() =>
                  navigate(
                    `${routes.CONTRACTS}${subRoutes.CONTRACTS.PORTFOLIO_CONTRACTS}`
                  )
                }
              >
                Voir mes contrats
              </Button>
            </Col>
          </>
        ) : (
          customerShortcuts.map((shortcut) => (
            <Col xs={24} sm={12} key={shortcut.title}>
              <Button
                onClick={() => navigate(shortcut.path)}
                style={{ width: '100%', maxWidth: 'none' }}
              >
                {shortcut.title}
              </Button>
            </Col>
          ))
        )}
      </Row>
    </Card>
  );
};

export { ShortcutsCard };
